/* eslint-disable no-restricted-syntax */

import "./scss/style.scss";
import Alpine from "alpinejs";
import DownloadJS from "downloadjs";
import Cookies from "./js/template-parts/popups/cookies";
import ModulesLoader from "./js/modules-loader";
import Barba from "./js/lib/barba";
import ScriptsLoaded from "./js/lib/scripts-loaded";
import StylesLoaded from "./js/lib/styles-loaded";

// Load objects
window.objectsLoaded = false;

document.addEventListener("DOMContentLoaded", () => {
  // BarbaJS
  window.barba = new Barba();
});

window.addEventListener("load", () => {
  if (window.objectsLoaded === false) {
    window.captchaLoaded = false;
    window.googleapi = false;
    // Ajax requests
    window.ajaxReq = function ajaxReq() {
      if (window.XMLHttpRequest) {
        return new XMLHttpRequest(); // eslint-disable-line
      }

      if (window.ActiveXObject) {
        return new ActiveXObject("Microsoft.XMLHTTP"); // eslint-disable-line no-console
      }

      console.log("Browser does not support XMLHTTP."); // eslint-disable-line no-console
      return false;
    };

    // AlpineJS
    window.Alpine = Alpine;
    // DownloadJS (to allow download .ics files with javascript).
    window.DownloadJS = DownloadJS;
    Alpine.start();

    // Load JS scripts
    window.loadJS = function loadJS(file, callback) {
      // DOM: Create the script element
      const jsElm = document.createElement("script");
      // set the type attribute
      jsElm.type = "application/javascript";
      // make the script element load file
      jsElm.src = file;
      // add a callback
      jsElm.addEventListener("load", callback);
      // finally insert the element to the body element in order to load the script
      document.body.appendChild(jsElm);
    };

    // Modules loader
    window.modulesLoader = new ModulesLoader();
    window.modulesLoader.loadModules();

    // Scripts and styles html tags compatibility with BarbaJS
    window.initializedScripts = ScriptsLoaded();
    window.initializedStyles = StylesLoaded();

    // Disable scroll
    // Disable scroll
    window.disableScroll = function disableScroll() {
      document.body.classList.add("u-block-scroll");
    };

    // Enable scroll
    window.enableScroll = function enableScroll() {
      document.body.classList.remove("u-block-scroll");
    };
    // Cookies banner
    window.cookies = new Cookies();

    window.objectsLoaded = true;
  }
});
